import { db, storage } from "./config"
import { getSellerIdsForUser } from "./shopify"
import { getDocsWhereIn } from "./queries"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc, deleteDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

export const getPurchasedListings = async (userId) => {
    try {
        // Reference to the "sales" collection
        const salesRef = collection(db, "sales")

        const sales = []

        // Create a query to filter sales by sellerId
        const q = query(salesRef, where("sender", "==", userId))
        const querySnapshot = await getDocs(q)

        querySnapshot.forEach((doc) => {
            sales.push({ id: doc.id, ...doc.data() })
        })

        return sales // Return the array of sales
    } catch (e) {
        console.error("Error getting documents: ", e)
        return [] // Return an empty array in case of error
    }
}

export const getSoldListings = async (userId) => {
    try {
        // Reference to the "sales" collection
        const salesRef = collection(db, "sales")

        const sales = []

        // Create a query to filter sales by sellerId
        // Includes sales through any Shopify store this account owns -- those
        // carry the store's role id as receiver, not the owner's uid.
        const querySnapshot = await getDocsWhereIn(salesRef, "receiver", await getSellerIdsForUser(userId))

        querySnapshot.forEach((doc) => {
            sales.push({ id: doc.id, ...doc.data() })
        })

        return sales // Return the array of sales
    } catch (e) {
        console.error("Error getting documents: ", e)
        return [] // Return an empty array in case of error
    }
}

export const addReview = async ({ saleId, title, description, rating, reviewer }) => {
    try {
        const salesRef = doc(db, 'sales', saleId);

        // Update the document with the new review
        await updateDoc(salesRef, {
            review: {
                title,
                description,
                rating,
                reviewer_name: reviewer.displayName,
                created_at: new Date().toISOString() // Optional: add a timestamp
            }
        });

        console.log('Review added successfully');
    } catch (error) {
        console.error('Error adding review: ', error);
    }
};